import gsap from 'gsap'

import { SharedAnimation, titleRevealAnimation } from './shared'
import { Animation } from '@/types'

export const simpleText = ({ node, reverse, mobile, context }: Animation) => {
  if (mobile) return

  const selector = context?.selector || gsap.utils.selector(node)

  const paragraph = selector('[data-motion-paragraph]')[0]

  const scrollTrigger = {
    trigger: node,
    once: !reverse,
    start: 'top 80%',
    markers: false,
    toggleActions: `play none none ${reverse ? 'reverse' : 'none'}`
  }

  const timeline = gsap.timeline({
    scrollTrigger
  })

  let paragraphAnimation: SharedAnimation
  if (paragraph) {
    paragraphAnimation = titleRevealAnimation(paragraph, reverse)
    timeline.add(paragraphAnimation.timeline, '<')
  }

  return () => {
    if (paragraphAnimation) {
      paragraphAnimation.revert()
    }
  }
}
